import { render, staticRenderFns } from "./Sankey.vue?vue&type=template&id=2d5b87d4"
import script from "./Sankey.vue?vue&type=script&lang=js"
export * from "./Sankey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports